export function isValueExists(parametersValue) {
  return parametersValue !== undefined && parametersValue !== '' && parametersValue !== '-';
}
